import React, { useState } from 'react';
import { Menu, X, Calendar, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="flex-between" style={{ height: '72px' }}>
          {/* Logo */}
          <div className="flex" style={{ alignItems: 'center', gap: '1rem' }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_02301d40-e1b7-4c3b-a98b-eccef76882c0/artifacts/b3rtseg4_Logo%20rond%20%2B%20%C3%A9criture%20transparent.png" 
              alt="ActiV Patrimoine.fr" 
              style={{ height: '50px', width: 'auto' }}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:block">
            <ul className="nav-list">
              <li><a href="#accueil" className="nav-link">Accueil</a></li>
              <li><a href="#services" className="nav-link">Services</a></li>
              <li><a href="#a-propos" className="nav-link">À Propos</a></li>
              <li><a href="#avis" className="nav-link">Avis Clients</a></li>
              <li><a href="#contact" className="nav-link">Contact</a></li>
            </ul>
          </nav>

          {/* CTA Buttons */}
          <div className="flex" style={{ alignItems: 'center', gap: '1rem' }}>
            <a href="tel:06.89.30.02.92" className="btn-ghost hidden md:flex">
              <Phone size={16} />
              06 89 30 02 92
            </a>
            <a 
              href="https://calendly.com/arthur-vacogne-rdv/rdv-echange-1er-prise-de-contact" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
            >
              <Calendar size={16} />
              Rendez-vous gratuit
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden"
              style={{ 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer',
                color: 'var(--text-primary)'
              }}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden" style={{ 
            position: 'absolute',
            top: '72px',
            left: 0,
            right: 0,
            background: 'var(--bg-overlay)',
            backdropFilter: 'blur(12px)',
            borderTop: '1px solid var(--border-light)',
            padding: '1rem'
          }}>
            <ul className="nav-list">
              <li><a href="#accueil" className="nav-link" onClick={() => setIsMenuOpen(false)}>Accueil</a></li>
              <li><a href="#services" className="nav-link" onClick={() => setIsMenuOpen(false)}>Services</a></li>
              <li><a href="#a-propos" className="nav-link" onClick={() => setIsMenuOpen(false)}>À Propos</a></li>
              <li><a href="#avis" className="nav-link" onClick={() => setIsMenuOpen(false)}>Avis Clients</a></li>
              <li><a href="#contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;